import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface Location_TypeAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  description: string;
  name: string;
  tenant: OD3_Tenant;
  value: number;
}

export class Location_Type extends Parse.Object<Location_TypeAttributes> {
  static className: string = "OD3_GTFS_Location_Type";

  constructor(data?: Partial<Location_TypeAttributes>) {
    super("OD3_GTFS_Location_Type", data as Location_TypeAttributes);
  }

  get description(): string {
    return super.get("description");
  }
  set description(value: string) {
    super.set("description", value);
  }
  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
  get value(): number {
    return super.get("value");
  }
  set value(value: number) {
    super.set("value", value);
  }
}

Parse.Object.registerSubclass("OD3_GTFS_Location_Type", Location_Type);
